var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/register"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20 7.885h-4.323a1.3 1.3 0 0 1-1.3-1.3V2M20 7.885 14.377 2M20 7.885V18a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-.193l.043-11.55V5a3 3 0 0 1 3-3h7.334M7.5 12h9.26m-2.26 2.5-3 3.5-2-1.5M7.5 9h5m-5-3H10",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.ddda5257d2cbee45fa2c0bc80d193f00.svg";
export { ForwardRef as ReactComponent };